<template>
    <div style="margin-top: 65px; margin-bottom:16px; text-align: center">
        Solo para miembros de secretaría
    <div id="firebaseui-auth-container"></div>
    <div id="loader">Loading...</div>
    </div>
</template>

<script>
    import { auth } from 'firebaseui'
    export default {
        name: "login",
        data: function () {
            return{
                ui: null,
            }
        },
        computed: {
            config (){
                return {
                    callbacks: {
                        signInSuccessWithAuthResult : this.signInSuccessWithAuthResult,
                        uiShown: () => {  document.getElementById('loader').style.display = 'none'  }
                    },
                    signInFlow: 'popup',
                    signInSuccessUrl: '',
                    signInOptions: [
                        {
                            provider: this.$firebase.auth.GoogleAuthProvider.PROVIDER_ID,
                            scopes: ['https://www.googleapis.com/auth/plus.login'   ]
                        },
                        this.$firebase.auth.EmailAuthProvider.PROVIDER_ID,
                        // {
                        //     provider: this.$firebase.auth.PhoneAuthProvider.PROVIDER_ID,
                        //     recaptchaParameters: {
                        //         type: 'image', // 'audio'
                        //         size: 'invisible', // 'invisible' or 'compact'
                        //         badge: 'inline' //' bottomright' or 'inline' applies to invisible.
                        //     },
                        //     defaultCountry: 'ES', // Set default country to the United Kingdom (+44).
                        //     loginHint: '+34649325412'
                        // }
                    ],
                    credentialHelper: auth.CredentialHelper.NONE,
                }
            }
        },
        methods: {
            signInSuccessWithAuthResult(authResult, redirectUrl) {
                this.$router.push({'name':'home'})
                return false;
            }
        },
        created() {
            this.$firebase.auth().languageCode = 'es';
        },
        mounted(){

            this.ui = auth.AuthUI.getInstance();

            if (!this.ui) {
                this.ui = new auth.AuthUI(this.$firebase.auth());
            }
            this.ui.start('#firebaseui-auth-container', this.config)
            this.$store.dispatch('init')
        }

    }
</script>

<style>
    @import url(https://fonts.googleapis.com/css?family=Roboto:400,500,700);

    #firebaseui-auth-container{
        min-width: 70vw;
        min-height: 60vh;
    }

.mdl-button.mdl-button--colored{color:white !important;}
.mdl-button--raised.mdl-button--colored{background:#FF6D00 !important;}
.mdl-button--raised.mdl-button--colored:hover{background-color:#FF6D00 !important}
.mdl-button--raised.mdl-button--colored:active{background-color:#FF6D00 !important}
.mdl-button--raised.mdl-button--colored:focus:not(:active){background-color:#FF6D00 !important}

.mdl-button--fab.mdl-button--colored{background:#ff4081;}
.mdl-button--fab.mdl-button--colored:hover{background-color:#ff4081}
.mdl-button--fab.mdl-button--colored:focus:not(:active){background-color:#ff4081}
.mdl-button--fab.mdl-button--colored:active{background-color:#ff4081}

.mdl-button--primary.mdl-button--primary{color:#FF6D00 !important}
.mdl-button--primary.mdl-button--primary.mdl-button--fab,.mdl-button--primary.mdl-button--primary.mdl-button--raised{background-color:#FF6D00 !important}

.mdl-button--accent.mdl-button--accent{color:#ff4081}

.mdl-button--accent.mdl-button--accent.mdl-button--fab,.mdl-button--accent.mdl-button--accent.mdl-button--raised{background-color:#ff4081}


.grecaptcha-badge{
    margin: 32px;
}

.mdl-card__media{background-color:#ff4081;}

.mdl-progress>.progressbar{background-color:#FF6D00;}

.mdl-progress>.bufferbar{background-image:linear-gradient(to right,rgba(255,255,255,.7),rgba(255,255,255,.7)),linear-gradient(to right,#FF6D00,#FF6D00);
z-index:0;
left:0}

.mdl-progress>.auxbar{right:0}@supports (-webkit-appearance:none){.mdl-progress:not(.mdl-progress--indeterminate):not(.mdl-progress--indeterminate)>.auxbar,.mdl-progress:not(.mdl-progress__indeterminate):not(.mdl-progress__indeterminate)>.auxbar{background-image:linear-gradient(to right,rgba(255,255,255,.7),rgba(255,255,255,.7)),linear-gradient(to right,#FF6D00,#FF6D00);}}

.mdl-progress:not(.mdl-progress--indeterminate)>.auxbar,.mdl-progress:not(.mdl-progress__indeterminate)>.auxbar{background-image:linear-gradient(to right,rgba(255,255,255,.9),rgba(255,255,255,.9)),linear-gradient(to right,#FF6D00,#FF6D00)}

.mdl-progress.mdl-progress--indeterminate>.bar1,.mdl-progress.mdl-progress__indeterminate>.bar1{background-color:#FF6D00;}

.mdl-progress.mdl-progress--indeterminate>.bar3,.mdl-progress.mdl-progress__indeterminate>.bar3{
background-color:#FF6D00;}

.mdl-spinner__layer-1{border-color:#42a5f5}

.mdl-spinner--single-color .mdl-spinner__layer-1{border-color:#FF6D00}

.mdl-spinner.is-active .mdl-spinner__layer-1{animation:mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4,0,.2,1) infinite both,mdl-spinner__layer-1-fade-in-out 5332ms cubic-bezier(.4,0,.2,1) infinite both}

.mdl-spinner__layer-2{border-color:#f44336}

.mdl-spinner--single-color .mdl-spinner__layer-2{border-color:#FF6D00}

.mdl-spinner.is-active .mdl-spinner__layer-2{animation:mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4,0,.2,1) infinite both,mdl-spinner__layer-2-fade-in-out 5332ms cubic-bezier(.4,0,.2,1) infinite both}

.mdl-spinner__layer-3{border-color:#fdd835}

.mdl-spinner--single-color .mdl-spinner__layer-3{border-color:#FF6D00}

.mdl-spinner.is-active .mdl-spinner__layer-3{animation:mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4,0,.2,1) infinite both,mdl-spinner__layer-3-fade-in-out 5332ms cubic-bezier(.4,0,.2,1) infinite both}

.mdl-spinner__layer-4{border-color:#4caf50}

.mdl-spinner--single-color .mdl-spinner__layer-4{border-color:#FF6D00}

.mdl-spinner.is-active .mdl-spinner__layer-4{animation:mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4,0,.2,1) infinite both,mdl-spinner__layer-4-fade-in-out 5332ms cubic-bezier(.4,0,.2,1) infinite both}@keyframes mdl-spinner__fill-unfill-rotate{12.5%{transform:rotate(135deg)}25%{transform:rotate(270deg)}37.5%{transform:rotate(405deg)}50%{transform:rotate(540deg)}62.5%{transform:rotate(675deg)}75%{transform:rotate(810deg)}87.5%{transform:rotate(945deg)}to{transform:rotate(1080deg)}}@keyframes mdl-spinner__layer-1-fade-in-out{from{opacity:.99}25%{opacity:.99}26%{opacity:0}89%{opacity:0}90%{opacity:.99}100%{opacity:.99}}@keyframes mdl-spinner__layer-2-fade-in-out{from{opacity:0}15%{opacity:0}25%{opacity:.99}50%{opacity:.99}51%{opacity:0}}@keyframes mdl-spinner__layer-3-fade-in-out{from{opacity:0}40%{opacity:0}50%{opacity:.99}75%{opacity:.99}76%{opacity:0}}@keyframes mdl-spinner__layer-4-fade-in-out{from{opacity:0}65%{opacity:0}75%{opacity:.99}90%{opacity:.99}100%{opacity:0}}

.mdl-spinner__gap-patch{position:absolute;
box-sizing:border-box;
top:0;
left:45%;
width:10%;
height:100%;
overflow:hidden;
border-color:inherit}

.mdl-spinner__gap-patch .mdl-spinner__circle{width:1000%;
left:-450%}

.mdl-spinner__circle-clipper{display:inline-block;
position:relative;
width:50%;
height:100%;
overflow:hidden;
border-color:inherit}

.mdl-spinner__circle-clipper.mdl-spinner__left{float:left}

.mdl-spinner__circle-clipper.mdl-spinner__right{float:right}

.mdl-spinner__circle-clipper .mdl-spinner__circle{width:200%}

.mdl-spinner__circle{box-sizing:border-box;
height:100%;
border-width:3px;
border-style:solid;
border-color:inherit;
border-bottom-color:transparent!important;
border-radius:50%;
animation:none;
position:absolute;
top:0;
right:0;
bottom:0;
left:0}

.mdl-spinner__left .mdl-spinner__circle{border-right-color:transparent!important;
transform:rotate(129deg)}

.mdl-spinner.is-active .mdl-spinner__left .mdl-spinner__circle{animation:mdl-spinner__left-spin 1333ms cubic-bezier(.4,0,.2,1) infinite both}

.mdl-spinner__right .mdl-spinner__circle{left:-100%;
border-left-color:transparent!important;
transform:rotate(-129deg)}

.mdl-spinner.is-active .mdl-spinner__right .mdl-spinner__circle{animation:mdl-spinner__right-spin 1333ms cubic-bezier(.4,0,.2,1) infinite both}@keyframes mdl-spinner__left-spin{from{transform:rotate(130deg)}50%{transform:rotate(-5deg)}to{transform:rotate(130deg)}}@keyframes mdl-spinner__right-spin{from{transform:rotate(-130deg)}50%{transform:rotate(5deg)}to{transform:rotate(-130deg)}}

.mdl-textfield{position:relative;
font-size:16px;
display:inline-block;
box-sizing:border-box;
width:300px;
max-width:100%;
margin:0;
padding:20px 0}

.mdl-textfield .mdl-button{position:absolute;
bottom:20px}

.mdl-textfield--align-right{text-align:right}

.mdl-textfield--full-width{width:100%}

.mdl-textfield--expandable{min-width:32px;
width:auto;
min-height:32px}

.mdl-textfield--expandable .mdl-button--icon{top:16px}

.mdl-textfield__input{border:none;
border-bottom:1px solid rgba(0,0,0,.12);
display:block;
font-size:16px;
font-family:Helvetica,Arial,sans-serif;
margin:0;
padding:4px 0;
width:100%;
background:0 0;
text-align:left;
color:inherit}

.mdl-textfield__input[type=number]{
    -moz-appearance: textfield;
    appearance: textfield;
}

.mdl-textfield__input[type=number]::-webkit-inner-spin-button,.mdl-textfield__input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;
margin:0}

.mdl-textfield.is-focused .mdl-textfield__input{outline:0}

.mdl-textfield.is-invalid .mdl-textfield__input{border-color:#d50000;
box-shadow:none}

.mdl-textfield.is-disabled .mdl-textfield__input,fieldset[disabled] .mdl-textfield .mdl-textfield__input{background-color:transparent;
border-bottom:1px dotted rgba(0,0,0,.12);
color:rgba(0,0,0,.26)}

.mdl-textfield textarea.mdl-textfield__input{display:block}

.mdl-textfield__label{bottom:0;
color:rgba(0,0,0,.26);
font-size:16px;
left:0;
right:0;
pointer-events:none;
position:absolute;
display:block;
top:24px;
width:100%;
overflow:hidden;
white-space:nowrap;
text-align:left}

.mdl-textfield.has-placeholder .mdl-textfield__label,.mdl-textfield.is-dirty .mdl-textfield__label{visibility:hidden}

.mdl-textfield--floating-label .mdl-textfield__label{transition-duration:.2s;
transition-timing-function:cubic-bezier(.4,0,.2,1)}

.mdl-textfield--floating-label.has-placeholder .mdl-textfield__label{transition:none}

.mdl-textfield.is-disabled.is-disabled .mdl-textfield__label,fieldset[disabled] .mdl-textfield .mdl-textfield__label{color:rgba(0,0,0,.26)}

.mdl-textfield--floating-label.has-placeholder .mdl-textfield__label,.mdl-textfield--floating-label.is-dirty .mdl-textfield__label,.mdl-textfield--floating-label.is-focused .mdl-textfield__label{color:#FF6D00;
font-size:12px;
top:4px;
visibility:visible}

.mdl-textfield--floating-label.has-placeholder .mdl-textfield__expandable-holder .mdl-textfield__label,.mdl-textfield--floating-label.is-dirty .mdl-textfield__expandable-holder .mdl-textfield__label,.mdl-textfield--floating-label.is-focused .mdl-textfield__expandable-holder .mdl-textfield__label{top:-16px}

.mdl-textfield--floating-label.is-invalid .mdl-textfield__label{color:#d50000;
font-size:12px}

.mdl-textfield__label:after{background-color:#FF6D00;
bottom:20px;
content:'';
height:2px;
left:45%;
position:absolute;
transition-duration:.2s;
transition-timing-function:cubic-bezier(.4,0,.2,1);
visibility:hidden;
width:10px}

.mdl-textfield.is-focused .mdl-textfield__label:after{left:0;
visibility:visible;
width:100%}

.mdl-textfield.is-invalid .mdl-textfield__label:after{background-color:#d50000}

.mdl-textfield__error{color:#d50000;
position:absolute;
font-size:12px;
margin-top:3px;
visibility:hidden;
display:block}

.mdl-textfield.is-invalid .mdl-textfield__error{visibility:visible}

.mdl-textfield__expandable-holder{display:inline-block;
position:relative;
margin-left:32px;
transition-duration:.2s;
transition-timing-function:cubic-bezier(.4,0,.2,1);
display:inline-block;
max-width:.1px}

.mdl-textfield.is-dirty .mdl-textfield__expandable-holder,.mdl-textfield.is-focused .mdl-textfield__expandable-holder{max-width:600px}

._dialog_overlay{position:fixed;
top:0;
right:0;
bottom:0;
left:0}dialog.fixed{position:fixed;
top:50%;
transform:translate(0,-50%)}

.firebaseui-container{background-color:#fff;
box-sizing:border-box;
-moz-box-sizing:border-box;
-webkit-box-sizing:border-box;
color:rgba(0,0,0,.87);
direction:ltr;
font:16px Roboto,arial,sans-serif;
margin:0 auto;
max-width:360px;
overflow:hidden;
position:relative;
text-align:left;
width:100%}

.firebaseui-card-header{padding:24px 24px 0 24px}

.firebaseui-card-content{padding:0 24px}

.firebaseui-card-footer{padding:0 24px}

.firebaseui-card-actions{box-sizing:border-box;
display:table;
font-size:14px;
padding:8px 24px 24px 24px;
text-align:left;
width:100%}

.firebaseui-form-links{display:table-cell;
vertical-align:middle;
width:100%}

.firebaseui-form-actions{display:table-cell;
text-align:right;
white-space:nowrap;
width:100%}

.firebaseui-subtitle,.firebaseui-title{color:rgba(0,0,0,.87);
direction:ltr;
font-size:20px;
font-weight:500;
line-height:24px;
margin:0;
padding:0;
text-align:left}

.firebaseui-title{padding-bottom:20px}

.firebaseui-subtitle{margin:16px 0}

.firebaseui-text{color:rgba(0,0,0,.87);
direction:ltr;
font-size:16px;
line-height:24px;
text-align:left}

.firebaseui-text-emphasis{font-weight:700}

.firebaseui-error{color:#dd2c00;
direction:ltr;
font-size:12px;
line-height:16px;
margin:0;
text-align:left}

.firebaseui-text-input-error{margin:-16px 0 16px}

.firebaseui-error-wrapper{min-height:16px}

.firebaseui-list-item{direction:ltr;
margin:0;
padding:0;
text-align:left}

.firebaseui-hidden{display:none}

.firebaseui-relative-wrapper{position:relative}

.firebaseui-label{color:rgba(0,0,0,.54);
direction:ltr;
font-size:16px;
text-align:left}

.mdl-textfield--floating-label.is-dirty .mdl-textfield__label,.mdl-textfield--floating-label.is-focused .mdl-textfield__label{color:#757575}

.firebaseui-input,.firebaseui-input-invalid{border-radius:0;
color:rgba(0,0,0,.87);
direction:ltr;
font-size:16px;
width:100%}input.firebaseui-input,input.firebaseui-input-invalid{direction:ltr;
text-align:left}

.firebaseui-input-invalid{border-color:#dd2c00}

.firebaseui-textfield{width:100%}

.firebaseui-textfield.mdl-textfield .firebaseui-input{border-color:rgba(0,0,0,.12)}

.firebaseui-textfield.mdl-textfield .firebaseui-label::after{background-color:#FF6D00}

.firebaseui-textfield-invalid.mdl-textfield .firebaseui-input{border-color:#dd2c00}

.firebaseui-textfield-invalid.mdl-textfield .firebaseui-label::after{background-color:#dd2c00}

.firebaseui-button{display:inline-block;
height:36px;
margin-left:8px;
min-width:88px}

.firebaseui-link{color: #ff8700;
font-variant:normal;
font-weight:400;
text-decoration:none}

.firebaseui-link:hover{text-decoration:underline}

.firebaseui-indent{margin-left:1em}

.firebaseui-tos{color:#757575;
direction:ltr;
font-size:12px;
line-height:16px;
margin-bottom:24px;
margin-top:0;
text-align:left}

.firebaseui-page-provider-sign-in{background:inherit}

.firebaseui-idp-list{list-style:none;
margin:1em 0;
padding:0}

.firebaseui-idp-button{direction:ltr;
font-weight:500;
height:auto;
line-height:normal;
max-width:220px;
min-height:40px;
padding:8px 16px;
text-align:left;
width:100%}

.firebaseui-idp-list>.firebaseui-list-item{margin-bottom:15px;
text-align:center}

.firebaseui-idp-icon-wrapper{display:table-cell;
vertical-align:middle}

.firebaseui-idp-icon{border:none;
display:inline-block;
height:18px;
vertical-align:middle;
width:18px}

.firebaseui-idp-favicon{border:none;
display:inline-block;
height:14px;
margin-right:5px;
vertical-align:middle;
width:14px}

.firebaseui-idp-text{color:#fff;
display:table-cell;
font-size:14px;
padding-left:16px;
text-transform:none;
vertical-align:middle}

.firebaseui-idp-text.firebaseui-idp-text-long{display:table-cell}

.firebaseui-idp-text.firebaseui-idp-text-short{display:none}@media (max-width:268px){.firebaseui-idp-text.firebaseui-idp-text-long{display:none}

.firebaseui-idp-text.firebaseui-idp-text-short{display:table-cell}}@media (max-width:320px){.firebaseui-recaptcha-container>div>div{transform:scale(.9);
-webkit-transform:scale(.9);
transform-origin:0 0;
-webkit-transform-origin:0 0}}

.firebaseui-idp-password,.firebaseui-idp-password:hover,.mdl-button.firebaseui-idp-password:active,.mdl-button.firebaseui-idp-password:focus{background-color:#db4437}

.firebaseui-idp-phone,.firebaseui-idp-phone:hover,.mdl-button.firebaseui-idp-phone:active,.mdl-button.firebaseui-idp-phone:focus{background-color:#02bd7e}

.firebaseui-idp-google,.firebaseui-idp-google:hover,.mdl-button.firebaseui-idp-google:active,.mdl-button.firebaseui-idp-google:focus{background-color:#fff}

.firebaseui-idp-google>.firebaseui-idp-text{color:#757575}

.firebaseui-idp-github,.firebaseui-idp-github:hover,.mdl-button.firebaseui-idp-github:active,.mdl-button.firebaseui-idp-github:focus{background-color:#333}

.firebaseui-idp-facebook,.firebaseui-idp-facebook:hover,.mdl-button.firebaseui-idp-facebook:active,.mdl-button.firebaseui-idp-facebook:focus{background-color:#3b5998}

.firebaseui-idp-twitter,.firebaseui-idp-twitter:hover,.mdl-button.firebaseui-idp-twitter:active,.mdl-button.firebaseui-idp-twitter:focus{background-color:#55acee}

.firebaseui-info-bar{background-color:#f9edbe;
border:1px solid #f0c36d;
box-shadow:0 2px 4px rgba(0,0,0,.2);
-webkit-box-shadow:0 2px 4px rgba(0,0,0,.2);
-moz-box-shadow:0 2px 4px rgba(0,0,0,.2);
left:10%;
padding:8px 16px;
position:absolute;
right:10%;
text-align:center;
top:0}

.firebaseui-info-bar-message{font-size:12px;
margin:0}

.firebaseui-dialog{box-sizing:border-box;
color:rgba(0,0,0,.87);
font:16px Roboto,arial,sans-serif;
height:auto;
padding:24px;
text-align:left}

.firebaseui-dialog-icon-wrapper{display:table-cell;
vertical-align:middle}

.firebaseui-dialog-icon{float:left;
height:40px;
margin-right:24px;
width:40px}

.firebaseui-progress-dialog-message{display:table-cell;
font-size:16px;
font-weight:400;
min-height:40px;
vertical-align:middle}

.firebaseui-progress-dialog-loading-icon{height:28px;
margin:6px 30px 6px 6px;
width:28px}

.firebaseui-icon-done{background-image:url(https://www.gstatic.com/images/icons/material/system/2x/done_googgreen_36dp.png);
background-position:center;
background-repeat:no-repeat;
background-size:36px 36px}

.firebaseui-phone-number{display:flex}

.firebaseui-country-selector{background-image:url(https://www.gstatic.com/images/icons/material/system/1x/arrow_drop_down_grey600_18dp.png);
background-position:right center;
background-repeat:no-repeat;
background-size:18px auto;
border-radius:0;
border-bottom:1px solid rgba(0,0,0,.12);
color:rgba(0,0,0,.87);
flex-shrink:0;
font-size:16px;
font-weight:400;
height:initial;
line-height:normal;
margin:20px 24px 20px 0;
padding:4px 20px 4px 0;
width:90px}

.firebaseui-country-selector-flag{display:inline-block;
margin-right:1ex}

.firebaseui-flag{background-image:url(https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/flags_sprite_2x.png);
background-size:100% auto;
filter:drop-shadow(1px 1px 1px rgba(0, 0, 0, .54));
height:14px;
width:24px}

.firebaseui-list-box-dialog{max-height:90%;
overflow:auto;
padding:8px 0 0 0}

.firebaseui-list-box-actions{padding-bottom:8px}

.firebaseui-list-box-icon-wrapper{display:table-cell;
padding-right:24px;
vertical-align:top}

.firebaseui-list-box-label-wrapper{display:table-cell;
vertical-align:top}

.firebaseui-list-box-dialog-button{color:rgba(0,0,0,.87);
direction:ltr;
font-size:16px;
font-weight:400;
height:initial;
line-height:normal;
min-height:48px;
padding:14px 24px;
text-align:left;
text-transform:none;
width:100%}

.firebaseui-phone-number-error{margin-left:114px}

.firebaseui-busy-indicator{height:2px;
left:0;
position:absolute;
top:55px;
width:100%}

.firebaseui-callback-indicator-container .firebaseui-busy-indicator{top:0}

.firebaseui-callback-indicator-container{height:120px}

.firebaseui-new-password-component{display:inline-block;
position:relative;
width:100%}

.firebaseui-input-floating-button{background-position:center;
background-repeat:no-repeat;
display:block;
height:24px;
position:absolute;
right:0;
top:20px;
width:24px}

.firebaseui-input-toggle-on{background-image:url(https://www.gstatic.com/images/icons/material/system/1x/visibility_black_24dp.png)}

.firebaseui-input-toggle-off{background-image:url(https://www.gstatic.com/images/icons/material/system/1x/visibility_off_black_24dp.png)}

.firebaseui-input-toggle-focus{opacity:.87}

.firebaseui-input-toggle-blur{opacity:.38}

.firebaseui-recaptcha-wrapper{display:table;
margin:0 auto;
 padding-top: 32px !important;
padding-bottom:8px}

.firebaseui-recaptcha-container{display:table-cell}

.firebaseui-recaptcha-error-wrapper{caption-side:bottom;
display:table-caption}

.firebaseui-change-phone-number-link{display:block}

.firebaseui-resend-container{direction:ltr;
margin:20px 0;
text-align:center}

.firebaseui-id-resend-countdown{color:rgba(0,0,0,.38)}

.firebaseui-id-page-phone-sign-in-start .firebaseui-form-actions div{float:left}@media (max-width:480px){.firebaseui-container{box-shadow:none;
max-width:none;
width:100%}

.firebaseui-card-header{border-bottom:1px solid #e0e0e0;
margin-bottom:16px;
padding:16px 24px 0 24px}

.firebaseui-title{padding-bottom:16px}

.firebaseui-card-actions{padding-right:24px}

.firebaseui-busy-indicator{top:0}}

.mdl-textfield__label{font-weight:400;
margin-bottom:0}

</style>